import { useEffect, useState } from "react";
import { clearStorage, getUserData } from "../../system";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../redux/actions";
import SharedSidebar from "../../shared/SharedSidebar";
import ProfileModal from "../../shared/ProfileModal";
import { modeConstants } from "../../constants";

const Header = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const profileData = getUserData();
  const Logout = (e) => {
    e.preventDefault();
    dispatch(userActions.logout());
  };
  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
              <div className="d-lg-none d-block">
        <button
          class="btn border-none"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasExample"
          aria-controls="offcanvasExample"
        >
          <i className="mdi mdi-menu fs-2 text-light"></i>
        </button>

        <div
          class="offcanvas offcanvas-start"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        > 
          <div class="offcanvas-body">
            <SharedSidebar />
          </div>
        </div>
      </div>
          </div>

          <div className="d-flex align-items-center">
            <ProfileModal
              showModal={showModal}
              onHide={() => setShowModal(false)}
              mode = {modeConstants?.UPDATE_MODE}
            />
            <div className="dropdown ms-sm-3 header-item">
              <button
                type="button"
                className="btn material-shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  {profileData?.pic_url ? (
                    <img
                      className="rounded-circle header-profile-user"
                      src={
                        process.env.REACT_APP_STORAGE_URL + profileData?.pic_url
                      }
                      alt="Header Avatar"
                    />
                  ) : (
                    <img
                      className="rounded-circle header-profile-user"
                      src="assets/images/users/avatar-1.png"
                      alt="Header Avatar"
                    />
                  )}

                  <span className="text-start ms-xl-2">
                    <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-light">
                      {profileData?.name}
                    </span>
                    {/* <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                      Founder
                    </span> */}
                  </span>
                </span>
              </button>

              <div className="dropdown-menu dropdown-menu-end">
                <h6 className="dropdown-header">
                  Welcome {profileData?.name}!
                </h6>

                {/*  use button to avoid anchor default, and open modal */}
                <button
                  className="dropdown-item"
                  onClick={() => setShowModal(true)}
                >
                  <i className="mdi mdi-key text-muted fs-16 align-middle me-1" />
                  <span className="align-middle" data-key="t-logout">
                    Profile
                  </span>
                </button>
                <button className="dropdown-item" onClick={Logout}>
                  <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
                  <span className="align-middle" data-key="t-logout">
                    Logout
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
